import type { ReferentialConditionRatings } from "./referential-condition-ratings.type";
import type { AssetConditionRating } from "@/entities/asset";
import type { Nullable } from "@/types";

import {
  REFERENTIAL_ENDPOINT,
  useDynamicReferential,
} from "@/entities/referential";

import { CONDITION_RATING_NOT_RATED } from "./referential-condition-ratings.constant";

export const useReferentialConditionRatings = () => {
  const { data, isLoading, ...result } =
    useDynamicReferential<ReferentialConditionRatings>(
      REFERENTIAL_ENDPOINT.CONDITION_RATINGS
    );

  const conditionRatings = data ?? [];

  const notRated = conditionRatings.find(
    (cr) => cr.rating === CONDITION_RATING_NOT_RATED
  );

  const getConditionRating = (value?: Nullable<AssetConditionRating>) => {
    if (isLoading) return undefined;

    return conditionRatings.find((cr) => cr.rating === value) ?? notRated;
  };

  return {
    ...result,
    conditionRatings,
    notRated,
    isLoading,
    getConditionRating,
  };
};

export const useReferentialConditionRatingsDefaultColor = () => {
  const { getReferentialAttr } = useReferentialConditionRatings();

  const defaultColor = getReferentialAttr(
    { rating: CONDITION_RATING_NOT_RATED },
    "color"
  );

  return defaultColor;
};
